import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de939a3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error__wrapper" }

import BasicSliderButton from '../../../../components/basic/BasicSliderButton.vue';
import { IonHeader, IonToolbar, IonTitle } from '@ionic/vue';
import { useRouter } from 'vue-router';

interface Props {
  code: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundArticle',
  props: {
    code: null
  },
  setup(__props: any) {

const props = __props as {
  code: string;
};



const router = useRouter();

const goBackToScan = () => router.push({ name: 'scan/article-find' });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode("Not found")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" Code \"" + _toDisplayString(props.code) + "\" failed to fetch resource due to api-error. ", 1),
      _createVNode(BasicSliderButton, { onOnSuccess: goBackToScan })
    ])
  ]))
}
}

})